import $ from 'jquery'
import FileUpload from '@/js/plugins/fileUpload'

const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

export default class extends FileUpload {
    defaults() {
        return {
            ...super.defaults(),
            typeFilter: ['image/jpeg', 'image/png', 'application/pdf', 'application/zip'],
            fileSizeLimit: 25,
            uploadPath: '/api/upload/secure/file',
            appendHeaders: {
                'X-CSRF-TOKEN': token,
            }
        }
    }

    loadedFile(element, reader, fileData) {
        this.settings.prevName = $(element).find('.preview p').text()
        $(element).find('.preview').addClass('is-uploading');
        $(element).find('.preview p').remove();
        const obj = $('<p />').text(fileData.name)
        $(element).find('.preview').prepend(obj);
    }

    uploadedFile(element, resp) {
        const name = $(element).find('.preview p').text();
        const anchorObj = $('<a />').attr('href', resp.url).attr('target', '_blank').text(name);
        console.log(anchorObj)
        $(element).find('.preview p').empty().append(anchorObj);
        $(element).find('.preview').removeClass('is-uploading');
        $(element).find('input.input-file').val(`${resp.name};${resp.key}`)
        this.triggerEvent($(element).find('input.input-file').get(0), 'change')
    }

    deletedFile(element, resp) {
        $(element).find('.preview p').remove();
        $(element).find('input.input-file').val('')
        $(element).find('.preview').removeClass('is-loaded');
        this.triggerEvent($(element).find('input.input-file').get(0), 'change')
    }

    error(element, params = null) {
        if (this.settings.prevName) {
            $(element).find('.preview p').text(this.settings.prevName)
        } else {
            $(element).find('.preview p').remove()
        }
        if (params && "description" in params){
            alert(params.description)
        }else{
            alert("ファイルのアップロードに失敗しました。\nファイルの形式やフォーマットをご確認ください。")
        }
    }
    triggerEvent(element, event){
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, true, true); // event type, bubbling, cancelable
        return element.dispatchEvent(evt);
    }
}
